
import { useStore } from '@/store'
import { BillingException } from '@/types/BillingException'
import Vue from 'vue'

export default Vue.extend({
  name: 'BillingExceptions',
  data() {
    return {
      email: '',
      loading: false,
    }
  },
  computed: {
    exceptionHeaders(): { text: string; value: string; width?: string; align?: string }[] {
      return [
        {
          text: 'Email',
          value: 'email',
          width: '90%',
        },
        {
          text: 'Actions',
          value: 'actions',
          width: '10%',
          align: 'center',
        },
      ]
    },
    exceptionEmails(): { id: string; email: string }[] {
      return this.billingException?.emails || []
    },
    exceptionEmailRules() {
      return [
        (newEmail: string) => {
          return this.isEmailValidByRegex(newEmail)
        },
      ]
    },
    isExceptionEmailValid(): boolean {
      return this.isEmailValidByRegex(this.email)
    },
    billingException(): BillingException | null {
      return useStore().billingExceptionModule.billingException
    },
  },
  methods: {
    isEmailValidByRegex(email: string): boolean {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      return emailRegex.test(email)
    },
    async handleExceptionDeleteClick(item: { email: string; id: string }) {
      const newEmails = this.exceptionEmails.filter((emailData) => emailData.id !== item.id)

      await this.$store.dispatch('billingExceptionModule/updateBillingException', {
        emails: newEmails,
      })
    },
    async handleAddEmailClick() {
      try {
        this.loading = true

        const newEmail = { email: this.email }

        if (this.exceptionEmails.length === 0) {
          // create

          await this.$store.dispatch('billingExceptionModule/createBillingException', {
            emails: [newEmail],
          })
        } else {
          // update

          await this.$store.dispatch('billingExceptionModule/updateBillingException', {
            emails: [...this.exceptionEmails, newEmail],
          })
        }

        this.email = ''
      } finally {
        this.loading = false
      }
    },
  },
})
